import React from "react";
import { withRouter } from "react-router-dom";

import { IconButton } from "@material-ui/core";
import { IoIosArrowBack } from "react-icons/io";

import useStyles from "./styles";

const Backbutton = ({ history }) => {
  const { button, buttonSize } = useStyles();
  return (
    <IconButton
      size="small"
      aria-label="back button"
      classes={{ sizeSmall: buttonSize }}
      className={button}
      onClick={() => history.goBack()}
    >
      <IoIosArrowBack />
    </IconButton>
  );
};

export default withRouter(Backbutton);
